
// Mixer Config
export const MixerFieldTemplate = {
  tabState: 0,
  colSpan: 5,
  application: 'blending',
  quantity: 1,
  size: '',
  mixerElement: '',
  elementsNumber: '',
  fixedRemove: '',
  elementMoc: '',
  elementMocOther: '',
  pipeSch: '',
  flangeRating: '',
  endConType: '',
  sideCon: false,
  sideConSize: '',
  sideConType: '',
  housingMoc: '',
  housingMocOther: '',
  orientation: '',
  designPressure: '',
  designTemperature: '',
  corrosionAllow: '',
  designCode: '',
  designCodeOther: '',
  validErrors: {},
  priceUnit: 0,
  length: 0,
  weight: 0,
  elementsOnly: false,
  picklePassivate: false,
  shipPrimer: false,
  specialPaint: false,
  hydroTest: false,
  rt: false,
  lpt: false,
  pmi: false,
  mpt: false,
  hardnessTesting: false,
  impactTesting: false,
  pwht: false,
  mtr_coc: false,
  electropolish: false,
  asmeStamp: false,
  peStamp: false,
  CRN: false,
  CRNTerritory: '',
  otherServices: false,
  otherServicesText: '',
  pressureDropUnits: 'psi',
  interfacialTensionUnits: 'dyne/cm',
  mixViscosityUnits: 'cP',
  mixDensityUnits: 'lb/ft3',
  mixFlowrateUnits: 'lb/hr',
  velocityUnits: 'ft/s',
}

// Mixer non-standard matrix
export const MixerNonStandard = {
  application: ['llDispersion', 'glContacting', 'glscrubbing', 'vapoerDesuper', 'heatExchanger'],
  size: [14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  mixerElement: ['SMXL-R', 'CompaX', 'SMF', 'SMI', 'Contour'],
  elementMoc: ['Low-Temp CS', '321', 'Super Duplex', '347', 'Duplex', 'Alloy 20', 'Alloy 400', 'Alloy 625', 'Alloy 825', 'Alloy C-276', 'Cr-Mo', 'FRP', 'PP', 'PTFE', 'PVDF', 'ETFE', 'PVC', 'CPVC', 'Other'],
  pipeSch: [5, 20, 30, 60, 100, 120, 140, 160],
  fixedRemove: [],
  orientation: [],
  designCode: [],
  flangeRating: ['900#', '1500#', '2500#'],
  endConType: ['LJ'],
  sideConSize: [14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  sideConType: ['LJ'],
  housingMoc: ['Low-Temp CS', '321', 'Super Duplex', '347', 'Duplex', 'Alloy 20', 'Alloy 400', 'Alloy 625', 'Alloy 825', 'Alloy C-276', 'Cr-Mo', 'FRP', 'PP', 'PTFE', 'PVDF', 'ETFE', 'PVC', 'CPVC', 'Other'],
  options: ['specialPaint', 'otherServices'],
  CRNTerritory: ['British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'],
  tubing: {
    size: [1, 6, 8],
    endConType: ['Plain ends'],
    housingMoc: ['321', 'Super Duplex', '347', 'Duplex', 'Alloy 20', 'Alloy 400', 'Alloy 625', 'Alloy 825', 'Alloy C-276', 'Cr-Mo', 'FRP', 'PP', 'PTFE', 'PVDF', 'ETFE', 'PVC', 'CPVC', 'Other'],
    mixerElement: [],
  }
}

// Mixer Element
export const fix_remove = {
  '': ['Fixed', 'Removable'],
  'SMV': ['Fixed', 'Removable'],
  'SMX': ['Fixed', 'Removable'],
  'SMX Plus': ['Fixed', 'Removable'],
  'SMXL-R': ['Fixed', 'Removable'],
  'KVM': ['Fixed'],
  'CompaX': ['Fixed', 'Removable'],
  'SMF': ['Fixed', 'Removable'],
  'SMI': ['Fixed', 'Removable'],
  'Contour':['Fixed', 'Removable']
}

export const element_type = ['SMV', 'SMX', 'SMX Plus', 'SMXL-R', 'KVM', 'CompaX', 'SMF', 'SMI', 'Contour']

// Element and Housing
export const moc = ['CS', 'Low-Temp CS', '316/316L', '304/304L', '321', '347', 'Duplex', 'Super Duplex', 'Alloy 20', 'Alloy 400', 'Alloy 625', 'Alloy 825', 'Alloy C-276', 'Cr-Mo', 'FRP', 'PP', 'PTFE', 'PVDF', 'ETFE', 'PVC', 'CPVC', 'Other']

export const size = [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42]

export const mainSize = {
  '': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMV': [1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMX': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMX Plus': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMXL-R': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'KVM': [2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'CompaX': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMF': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'SMI': [2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42],
  'Contour': [0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 36, 42]
}

export const tubingOptions = {
  size: {
    '': [0.75, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8],
    'SMV': [1.5, 2, 2.5, 3, 3.5, 4, 6, 8],
    'SMX': [0.75, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8],
    'SMX Plus': [0.75, 1.5, 2, 2.5, 3, 3.5, 4, 6, 8],
  },
  moc: ['316/316L', '304/304L', '321', '347', 'Duplex', 'Super Duplex', 'Alloy 20', 'Alloy 400', 'Alloy 625', 'Alloy 825', 'Alloy C-276', 'Cr-Mo', 'Other'],
  element_type: ['SMV', 'SMX', 'SMX Plus'],
  designCode: ['ASME B31.3 (Tube only)', 'Other']
}

// Housing
export const schedule = [5, 10, 20, 30, 40, 'STD', 60, 80, 'XH', 100, 120, 140, 160, 'Tubing (Standard)']

export const rating = ['150#', '300#', '600#', '900#', '1500#', '2500#']

export const ConType = {
  '': ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  5: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  10: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  20: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  30: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  40: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  'STD': ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  60: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  80: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  'XH': ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  100: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  120: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  140: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  160: ['RFWN', 'FFWN', 'RFSO', 'FFSO', 'LJ', 'Plain ends', 'Threaded', 'Weld-prep'],
  'Tubing (Standard)': ['Ferrule ends', 'Plain ends']
}

export const orientation = {
  '': ['Horizontal', 'Vertical', 'Vertical-Up', 'Vertical-Down', 'Horizontal or Vertical Down', 'Horizontal or Vertical Up'],
  'Fixed': ['Horizontal', 'Vertical', 'Vertical-Up', 'Vertical-Down', 'Horizontal or Vertical Down', 'Horizontal or Vertical Up'],
  'Removable': ['Horizontal', 'Vertical-Down']
}

// Design Parameters
export const designCode = ['ASME B31.3', 'ASME Sec. VIII Div. I', 'Other']

// Options
export function generateOptions(elementsOnly, schedule, endConType){
  let options = {
    'picklePassivate': 'Pickle and Passivate Element',
    'electropolish': 'Electropolish',
    'pmi': 'Positive Material Identification'
  };
  if(schedule === 'Tubing (Standard)'){
    options = {
      ...options,
      'hydroTest': 'Hydro Test',
      'otherServices': 'Other Services'
    }
  }else if(endConType === 'Plain ends' || endConType === 'Weld-prep' || endConType === 'Threaded'){
    options = {
      ...options,
      'specialPaint': 'Special Paint',
      'hardnessTesting': 'Hardness Testing',
      'impactTesting': 'Impact Testing',
      'pwht': 'Post Weld Heat Treatment',
      'asmeStamp': 'ASME Stamp',
      'CRN': 'Canadian Registration Number',
      'otherServices': 'Other Services'
    }
  }else if(!elementsOnly){
    options = {
      ...options,
      'specialPaint': 'Special Paint',
      'hydroTest': 'Hydro Test',
      'rt': 'Radiographic Testing (100% flange BW)',
      'lpt': 'Liquid Penetrant Testing',
      'mpt': 'Magnetic Particle Testing',
      'hardnessTesting': 'Hardness Testing',
      'impactTesting': 'Impact Testing',
      'pwht': 'Post Weld Heat Treatment',
      'asmeStamp': 'ASME Stamp',
      'CRN': 'Canadian Registration Number',
      'otherServices': 'Other Services'
    }
  }else{
    options = {
      ...options,
      'otherServices': 'Other Services'
    }
  }

  return options
}

export const optionshousingList = {
  'picklePassivate': 'Pickle and Passivate Element',
  'electropolish': 'Electropolish',
  'specialPaint': 'Special Paint',
  'hydroTest': 'Hydro Test',
  'rt': 'Radiographic Testing (100% flange BW)',
  'lpt': 'Liquid Penetrant Testing',
  'pmi': 'Positive Material Identification',
  'mpt': 'Magnetic Particle Testing',
  'hardnessTesting': 'Hardness Testing',
  'impactTesting': 'Impact Testing',
  'pwht': 'Post Weld Heat Treatment',
  'asmeStamp': 'ASME Stamp',
  'CRN': 'Canadian Registration Number',
  'otherServices': 'Other Services'
}

export const CRNTerritory = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon']

// Application
export const application = {
  "blending": "Miscible Blending",
  "llDispersion": "Liquid-Liquid Dispersion",
  "glContacting": "Gas-Liquid Contacting",
  "glscrubbing": "Gas-Liquid Scrubbing",
  "vapoerDesuper": "Vaporization / Desuperheating",
  "heatExchanger": "Thermal Homogenization / Heat Exchanger"
}

// Fluid Conditions
export const initialSetup = {
  cases: ['case1'],
  streams: ['stream1', 'stream2'],
  caseCount: 1,
  streamCount: 2
}

export const phaseFields = ['Gas', 'Aqueous Liquid', 'Hydrocarbon Liquid', 'Solid']

export const caseSimFields = ['mixDensity', 'mixViscosity', 'mixFlowrate', 'velocity', 'reynolds', 'flowRegime', 'recMixerType','estPressureDrop']

export const caseFields = {
  "blending": ['pressureDrop'],
  "llDispersion": ['pressureDrop'],
  "glContacting": ['pressureDrop', 'interfacialTension'],
  "glscrubbing":  ['pressureDrop', 'interfacialTension'],
  "vapoerDesuper": ['pressureDrop', 'interfacialTension'],
  "heatExchanger": ['pressureDrop'],
};

export const streamFields = {
  "blending": ['phase', 'flowrate', 'density', 'viscosity'],
  "llDispersion": ['phase', 'flowrate', 'density', 'viscosity'],
  "glContacting": ['phase', 'flowrate', 'density', 'viscosity', 'temp', 'pressure', 'moleWeight'],
  "glscrubbing":  ['phase', 'flowrate', 'density', 'viscosity', 'temp', 'pressure', 'moleWeight'],
  "vapoerDesuper": ['phase', 'flowrate', 'density', 'viscosity', 'heatCapacity', 'temp', 'pressure', 'moleWeight'],
  "heatExchanger": ['phase', 'flowrate', 'density', 'viscosity', 'heatCapacity', 'temp', 'pressure'],
};

export const streamUnits = {
  flowrateUnits: 'lb/hr',
  densityUnits: 'lb/ft3',
  viscosityUnits: 'cP',
  heatCapacityUnits: 'BTU/R*lb',
  tempUnits: '°F',
  pressureUnits: 'psig',
  moleWeightUnits: 'lb/mole'
};

export const unitSelections = {
  'pressureDrop': ['psi','Bar','mBar','kg/cm2','kPa'],
  'interfacialTension': ['dyne/cm','mN/m'],
  'flowrate': ['MMSCFD','SCFM','ACFM','GPM','lb/hr','kg/hr','m3/hr','Nm3/hr','m3/day','Liters/min','BPD'],
  'density': ['lb/ft3','Sp.Gr.','g/cm3','kg/m3'],
  'viscosity': ['cP','mPa-s'],
  'heatCapacity': ['BTU/R*lb','J/K*kg'],
  'temp': ['°F','°C'],
  'pressure': ['psig','psia','Bar-g','Bar-atm','kg/cm2-g','kPa-g','MPa-g'],
  'moleWeight': ['lb/mole','kg/mole','Gas Comp.']
}

export const FieldConfig = {
  'pressureDrop': 'Allowable Pressure Drop',
  'interfacialTension': 'Interfacial Tension',
  'phase': 'Phase',
  'flowrate': 'Flow Rate',
  'density': 'Density',
  'viscosity': 'Viscosity',
  'heatCapacity': 'Heat Capacity',
  'temp': 'Temperature',
  'pressure': 'Pressure',
  'moleWeight': 'Molecular Weight'
}

export const fieldTooltips = {
  application: {
    "blending": "Blending of gasses or liquids that form one homogeneous phase",
    "llDispersion": "Mixing of liquids that form two or more homogenious phases",
    "glContacting": "2-phase gas/liquid mass transfer in bubble flow",
    "glscrubbing": "2-phase gas/liquid mass transfer in mist flow",
    "vapoerDesuper": "Liquid vaporization through direct contact with a hot gas stream",
    "heatExchanger": "Reducing temperature deviations in combined streams or heat exchangers"
  },
  size: "Nominal size of mixer element",
  mixerElement: "Type of mixer element",
  elementsNumber: "Number of elements",
  fixedRemove: "Choose whether elements need to be removable",
  elementMoc: "Element material of construction",
  elementMocOther: "Other material for element",
  pipeSch: "Housing schedule for design",
  flangeRating: "ANSI flange rating",
  endConType: "End connections type",
  sideCon: "Select whether a side connection is needed",
  sideConSize: "Nominal size of side connection",
  sideConType: "End connection type for the side connection",
  housingMoc: "Housing material of construction",
  housingMocOther: "Other material for housing",
  orientation: "Orientation of the mixer",
  designPressure: "Design pressure of the system",
  designTemperature: "Design temperature of the system",
  corrosionAllow: "Corrosion allowance for the housing",
  designCode: "Design code for the housing",
  designCodeOther: "Other design code for the housing",
  elementsOnly: "Select if you want to purchase only the elements",
  picklePassivate: "Chemical treatment for stainless steel to improve resistance",
  shipPrimer: "Apply a shipping primer to the housing",
  specialPaint: "Special paint is needed to be applied to the housing",
  hydroTest: "Hydrotest of the housing",
  rt: "Radiographic testing of welds is needed",
  lpt: "Liquid penetrant testing of welds is needed",
  pmi: "Positive material identification is needed",
  mpt: "Magnetic particle testing of welds is needed",
  hardnessTesting: "Hardness testing of housing is needed",
  impactTesting: "Impact testing of housing is needed",
  pwht: "Post weld heat treatment of housing or elements is needed",
  mtr_coc: "Nominal size of mixer element",
  electropolish: "Electropolish stainless steel surface of housing",
  asmeStamp: "ASME stamp is needed for housing",
  CRN: "Canadian Registration Number needed for housing",
  CRNTerritory: "Select the territory the CRN is needed in",
  otherServices: "Select to add additional service requests"
}

export const smvWarningText = "The SMV family of mixers is a highly customizable design. Pricing and delivery are only preliminary estimates based on standard configurations. Final pricing and delivery will need to be confirmed by Sulzer upon submission. If this is a new mixer, please ensure to enter fluid conditions to ensure the mixer will be configured properly."

//Order Processing

export const marketSeg = ['Upstream (Oil and Gas Production and Transportation)', 'Crude Oil Refining', 'Downstream (Chemicals, Renewables, Other)']

export const sulzerApp = {
  'Upstream (Oil and Gas Production and Transportation)': ['Crude Oil Processing', 'Liquid Natural Gas (LNG)','Natural Gas (NG/CNG)', 'Natural Gas Part GTL Plant','NGL Separation', 'Others - Gas', 'Produced Water Treatment (PWT)','Sand management', 'Subsea Separation'],
  'Crude Oil Refining': ['Refinery', 'Upgrader'],
  'Downstream (Chemicals, Renewables, Other)': ['Others - Chemicals','Others - PetroChemicals', 'Acetates', 'Acetic Acid (HAc)','Acrylic Acid (AA), Acrylic Esters (AE) & Super Absorbent Polymer (SAP)','Acrylic Fiber (AF)', 'Acrylonitrile (ACN)', 'Adipic Acid','Air Separation', 'Alkylphenol', 'Allyl Alcohol', 'Ammonia (NH3)','Aniline', 'Benzene, Toluene & Xylene (BTX)', 'Benzoic Acid','Bio Monomers (Lactides)', 'Biodiesel, Glycerine','Bisphenol-A (BPA)', 'Butadiene (BD)','Butanediol 1,4 (1,4BDO) & Tetrahydrofuran (THF)', 'Butene-1','Butyraldehyde', 'Caprolactam (CPL)','Chlorine (Cl2) / Caustic Soda (NaOH) & Hydrogen Chlorine (HCl) and recovery of HCL, Phosgene','Chlorobenzene, Nitrochloro-Benzene & Nitrotoluene','Coal to Liq. (CTL), Gas to Liq. (GTL), Biomass to Liq. (BTL), Syn. Nat. Gas (SNG)','Coke Oven Gas, Coal Tar', 'Cosmetics & Detergents', 'Cyclohexane','Cyclohexanone (ON) / Cyclohexanol (OL)', 'Deaeration','Diisooctyl Phthalate (DOP)', 'Dimethyl Terephthalate (DMT)','Dimethylformacetamide (DMAc)', 'Dimethylformamide (DMF)','Edible Fats & Oil', 'Ethanolamine (EA)','Ethers: Methyl-Ter-butyl Ether (MTBE), Ethyl-Ter-Butyl Ether (ETBE), Ter-Amyl Ether (TAME)','Ethylbenzene (EB)', 'Ethylene & Propylene','Ethylene Dichloride (EDC) / Vinyl Chloride Monomer (VCM) & Polyvinyl Chloride (PVC)','Ethylene Glycol (EG)', 'Ethylene Oxide (EO)','Ethylene Oxide (EO)/Ethanolamine (EA)','Ethylene Oxide (EO)/Ethylene Glycol (EG)', 'Ethylhexanol-2 (2EH)','Fatty Acid', 'Fatty Acid Esters', 'Fatty Alcohol','Flavours, Fragrances & Vitamins','Flue Gas Treatment & Tail Gas Treatment', 'Food & Beverage','Formaldehyde', 'Formic Acid', 'Fractional Crystallization','Fuel Ethanol / Bioethanol', 'Gas to Liquid (GTL)','Glycol Ethers', 'Hydrogen Chloride (HCl) Recovery','Hydrogen Cyanide (HCN)', 'Hydrogen Peroxide (H2O2)','Inorganic Chemicals Others','Isophorone, Isophorone Diisocyanate (IPDI), Tolonate, Hexamethylene Diisocyanate (HDI)','Isopropyl Alcohol (IPA)', 'Isotopes', 'Maleic Anhydride (MAH)','Methanol (MeOH) Production', 'Methanol (MeOH) Recovery','Methionine', 'Methyl Formate', 'Methyl Methacrylate (MMA)','Methylal', 'Methylamine','Methylene Diphenyl Diisocyanate (MDI), Methylene Dianiline (MDA) incl. HMDI, HMDA','Methylene Diphenyl Diisocynate (MDI)/Methylene Dianiline (MD','Naphthalene / Naphthol', 'N-Butanol (BuOH)','Nitric Acid (HNO3), Ammonium Nitrate (NH4NO3)','Nitrous Oxide (NOx)', 'Nutraceuticals - Methionine','Nutraceuticals - Oleochemical based', 'Nutraceuticals - Others','Nutraceuticals - Vitamins', 'Pharmaceutical Active Ingredient','Phenol & Acetone, Cumene, Cresol', 'Phosphoric Acid','Phthalic Anhydride (PA)', 'Pilot and laboratory columns', 'Polycarbonate (PC)','Poly-Oxymethylene (POM)','Polyvinyl Acetate (PVA) / Polyvinyl Alcohol (PVA)','Power plants - CO2 Capture', 'Power Plants - Others','Propylene Oxide (PO)', 'Pulp & Paper','Purified Terephthalic Acid (PTA)', 'Reactive Resins & Adhesives','Rolling Oil Recovery', 'Silanes', 'Solvents Others','Solvents Pharmaceutical','Styrene Monomer (SM)/Ethylbenzene (EB)','Styrene Monomer/Propylene Oxide process (SMPO)', 'Sulfuric Acid','Synthesis Gas', 'Synthesis Gas Sweetening', 'Tall Oil','Toluene Diisocyanate (TDI)/Toluene Diamine (TDA)','Toluene Diisocynate (TDI)/Toluene Diamine (TDA)','Urea, Fertilizers', 'Vinyl Acetate Monomer (VAM)','Wastewater Treatment', 'Water & Wastewater']
}

export const paymentMethod = ['ACH', 'Wire', 'Check', 'Bank Card (Visa/Mastercard)']

export const shipMethod = ['Standard', 'Hot Shot', 'Customer pickup']

export const countryList = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "The Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Republic of the Congo", "Democratic Republic of the Congo", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor(Timor - Leste)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "The Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea - Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "North Korea", "South Korea", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Federated States of Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar(Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City(Holy See)", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"]
